{
  "validation": {
    "required": "Ce champ est obligatoire",
    "email": "Veuillez saisir une adresse e-mail valide",
    "minLength": "Doit comporter au moins {{min}} caractères",
    "maxLength": "Doit comporter au plus {{max}} caractères",
    "passwordMatch": "Les mots de passe ne correspondent pas"
  },
  "pagination": {
    "previous": "Précédent",
    "next": "Suivant",
    "page": "Page {{current}} sur {{total}}",
    "showing": "Affichage de {{from}} à {{to}} sur {{total}} résultats"
  },
  "table": {
    "noResults": "Aucun résultat trouvé",
    "loading": "Chargement des données...",
    "sortAsc": "Trier par ordre croissant",
    "sortDesc": "Trier par ordre décroissant"
  }
}
